function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import autoloadMixin from "../mixins/table/autoload.js";
import exportMixin from "../mixins/table/export.js";
import importMixin from "../mixins/table/import.js";
export default {
  mixins: [autoloadMixin, exportMixin, importMixin],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      sections: []
    };
  },
  computed: {
    output: function output() {
      // let str = ""
      // let count = 0
      // for (const section of this.sections) {
      //   for (const row of section.dataRows) {
      //     const name = row[2]
      //     const email = row[3]
      //     const createdAt = row[5]
      //     const activationState = row[14] ? 'active' : 'pending'
      //     count += 1
      //     if (email.includes("'")) {
      //       console.log("INVALID NAME", name)
      //     }
      //     str += `{ name: "${name}".to_s, email: '${email}'.to_s, created_at: '${createdAt}', activation_state: '${activationState}'},\n`
      //   }
      // }
      // return `Processing ${count} rows:\n[\n${str}\n]`
      return "";
    }
  },
  methods: {
    $ready: function $ready() {
      this.sections = this.spec.sections;

      var _iterator = _createForOfIteratorHelper(this.sections),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var section = _step.value;
          section.header = section.header || {}; // Use $set() to bind the nested property

          this.$set(section, "dataRows", []);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.autoloadAll(this.spec.nextPage);
      this.initCsvExport();
      this.initCsvImport();
      this.enableInfiniteScrollIfApplicable();
    },
    $tearDown: function $tearDown() {
      this.cancelAutoloadRequest();
    },
    clear: function clear(section) {
      section.rows = [];
      section.dataRows = [];
    },
    colSpan: function colSpan(row, index) {
      var spans = row.colSpans || [];
      return spans[index] || 1;
    },
    colStyles: function colStyles(row, index) {
      var colStyles = row.colStyles || [];
      return this.$styles(colStyles[index] || {});
    },
    rows: function rows(section) {
      return section.rows || [];
    },
    triggerImport: function triggerImport(index) {
      var input = this.$refs.fileInput[index];
      input.click();
    },
    totalRows: function totalRows(section) {
      return (section.rows || []).length + (section.dataRows || []).length;
    }
  }
};